import { render } from "./OrderCargoItemCard.vue?vue&type=template&id=87264244&scoped=true"
import script from "./OrderCargoItemCard.vue?vue&type=script&lang=js"
export * from "./OrderCargoItemCard.vue?vue&type=script&lang=js"

import "./OrderCargoItemCard.vue?vue&type=style&index=0&id=87264244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87264244"]])

export default __exports__